import React, { useMemo } from 'react'
import { TownsT } from '@components/TownsT/TownsT'
import { Box, BoxProps, Text } from '@ui'
import { formatUnits } from 'viem'

export type TownsReputationBadgeProps = {
    totalStaked: bigint
    withinParagraph?: boolean
    big?: boolean
    bold?: boolean
    logoColor?: BoxProps['color']
} & BoxProps

export const formatStakingBadgeNumber = Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 0,
})

export const TownsReputationBadge = React.memo(function TownsReputationBadge({
    totalStaked,
    big,
    bold,
    logoColor,
    withinParagraph,
    ...props
}: TownsReputationBadgeProps) {
    const formattedStaked = useMemo(
        () => formatStakingBadgeNumber.format(Number(formatUnits(totalStaked, 18))),
        [totalStaked],
    )
    return (
        <Box
            horizontal
            centerContent
            position="relative"
            display="inline-flex"
            height="paragraph"
            color="gray2"
            fontWeight="normal"
            tooltip={`${formattedStaked} $TOWNS staked`}
            gap={big ? 'xxs' : 'none'}
            {...props}
        >
            <Box
                // hacky because of baseline alignment
                style={{ height: big ? 16 : 12 }}
                alignSelf="center"
                color={logoColor}
            >
                <TownsT />
            </Box>
            <Box
                style={{ height: 10, marginTop: withinParagraph ? 2 : 0, letterSpacing: 0 }}
                justifyContent="center"
            >
                <Text size={big ? 'lg' : 'sm'} fontWeight={bold ? 'strong' : 'normal'}>
                    {formattedStaked}
                </Text>
            </Box>
        </Box>
    )
})

TownsReputationBadge.displayName = 'TownsReputationBadge'
